<div style="display: block" *ngIf="showChart">
   <canvas baseChart
      [datasets]="data"
      [labels]="label"
      [options]="lineChartOptions"
      [colors]="color"
      chartType="line">   
    </canvas>
</div>